import React from "react";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import PollOutlinedIcon from "@material-ui/icons/PollOutlined";
import RemoveCircleOutlineOutlinedIcon from "@material-ui/icons/RemoveCircleOutlineOutlined";
import PlayCircleOutlineRoundedIcon from "@material-ui/icons/PlayCircleOutlineRounded";

import { ReactComponent as CopyIcon } from "assets/images/copy.svg";
import dripModuleStyle from "../ActiveDrip/ActiveDrip.module.css";
import { RESOURCE_KEYS, orgPermissions } from "utils/OrgPermissions";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import useDripActions from "../ActiveDrip/useDripActions";

const usePausedDripActions = ({
  selectedDrip,
  setSelectedDrip,
  closeMobileOptions,
  openEndModal,
  openResumeModal,
}) => {
  const isDesktop = useDesktopMediaQuery();
  const writeDisabled = !orgPermissions.hasFeatureWriteAccess(
    RESOURCE_KEYS.SECTIONS.CUSTOM_MAILS
  );

  const { handleDuplication, handleEdit, handleViewAnalyticsPerEmail } =
    useDripActions({ selectedDrip });

  function handleResumeDrip(record) {
    if (isDesktop) setSelectedDrip(record);
    else closeMobileOptions();
    openResumeModal();
  }

  function handleInactivateDrip(record) {
    if (isDesktop) setSelectedDrip(record);
    closeMobileOptions();
    openEndModal();
  }

  const actions = [
    {
      icon: (
        <CreateOutlinedIcon
          className={
            isDesktop
              ? dripModuleStyle.desktopActionIcon
              : dripModuleStyle.blueAction
          }
        />
      ),
      onClick: handleEdit,
      label: "Edit drip",
      disabled: writeDisabled,
      className: dripModuleStyle.blueButton,
    },
    {
      icon: (
        <PollOutlinedIcon
          className={
            isDesktop
              ? dripModuleStyle.desktopActionIcon
              : dripModuleStyle.actionIcon
          }
        />
      ),
      onClick: handleViewAnalyticsPerEmail,
      label: "View analytics per email",
      className: dripModuleStyle.blackButton,
    },
    {
      icon: (
        <PlayCircleOutlineRoundedIcon
          className={
            isDesktop
              ? dripModuleStyle.desktopActionIcon
              : dripModuleStyle.actionIcon
          }
        />
      ),
      onClick: handleResumeDrip,
      label: "Resume drip",
      disabled: writeDisabled,
      className: dripModuleStyle.blackButton,
    },
    {
      icon: (
        <CopyIcon
          className={
            isDesktop
              ? dripModuleStyle.desktopActionIcon
              : dripModuleStyle.actionIcon
          }
        />
      ),
      onClick: handleDuplication,
      label: "Duplicate drip",
      disabled: writeDisabled,
      className: dripModuleStyle.blackButton,
    },
    {
      icon: (
        <RemoveCircleOutlineOutlinedIcon
          className={
            isDesktop
              ? dripModuleStyle.desktopActionIcon
              : dripModuleStyle.redAction
          }
        />
      ),
      onClick: handleInactivateDrip,
      label: "End drip",
      disabled: writeDisabled,
      className: dripModuleStyle.redButton,
    },
  ];

  return {
    writeDisabled,
    handleEdit,
    actions,
  };
};

export default usePausedDripActions;
